import LoadingSpinner from "@sprout/loading_spinner.tsx";
import { JobAlertsHeader } from "@components/job_alerts/header.tsx";

export const LoadingState = () => {
  return (
    <>
      <JobAlertsHeader />
      <div className="job-alerts-list__loading">
        <LoadingSpinner size="medium" />
      </div>
    </>
  );
};
